module.exports = __webpack_public_path__ + "img/no-image.7495cf05.jpg";